import { Hammer, Home, LockKeyhole, UnlockKeyhole, X } from 'lucide-react';
import { useState } from 'react';
import { formatMoney, GROUP_COLORS } from '../utils/board.js';

export function AssetDrawer({ open, onClose, game, viewerId, action }) {
  const [busy, setBusy] = useState(null);
  if (!open) return null;
  const me = game.players.find((player) => player.id === viewerId);
  const canManage = game.status === 'active' && (game.pendingDebt ? game.pendingDebt.debtorId === viewerId : game.currentPlayerId === viewerId);
  const canInvest = canManage && game.phase !== 'awaiting_debt';

  const perform = async (event, propertyId) => {
    setBusy(`${event}-${propertyId}`);
    try {
      await action(event, { propertyId });
    } catch {
      // Глобальное уведомление показывает причину.
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="drawer" role="dialog" aria-modal="true" aria-labelledby="assets-title">
        <header className="drawer__header"><div><span>Управление капиталом</span><h2 id="assets-title">Моё имущество</h2></div><button type="button" onClick={onClose} aria-label="Закрыть"><X /></button></header>
        <div className="asset-balance">Доступно: <strong>{formatMoney(me.money)}</strong></div>
        {!canManage && <p className="asset-readonly">Сейчас ход другого игрока: имущество доступно для просмотра, изменения временно заблокированы.</p>}
        <div className="asset-list">
          {me.properties.length === 0 && <p className="empty-state">Пока нет собственности. Свободные объекты можно покупать после попадания на них.</p>}
          {me.properties.map((propertyId) => {
            const cell = game.board[propertyId];
            const property = game.properties.find((item) => item.id === propertyId);
            const canBuildType = cell.type === 'street';
            const atlasIndex = game.properties.findIndex((item) => item.id === propertyId);
            const atlasColumn = atlasIndex % 7;
            const atlasRow = Math.floor(atlasIndex / 7);
            return (
              <article className="asset-row" key={propertyId} style={{ '--property-color': GROUP_COLORS[cell.group] ?? '#51616b' }}>
                <span className="asset-row__color" />
                <span className="asset-row__art" aria-hidden="true" style={{ backgroundPosition: `${(atlasColumn / 6) * 100}% ${(atlasRow / 3) * 100}%` }} />
                <div className="asset-row__body">
                  <div><strong>{cell.name}</strong><span>{property.mortgaged ? 'В ипотеке' : property.houses === 5 ? 'Отель' : property.houses ? `Домов: ${property.houses}` : 'Без построек'}</span></div>
                  <div className="asset-row__actions">
                    {canBuildType && !property.mortgaged && property.houses < 5 && <button type="button" onClick={() => perform('property:build', propertyId)} disabled={Boolean(busy) || !canInvest}><Hammer size={15} /> Построить · {formatMoney(cell.buildCost)}</button>}
                    {canBuildType && property.houses > 0 && <button type="button" onClick={() => perform('property:sell-building', propertyId)} disabled={Boolean(busy) || !canManage}><Home size={15} /> Продать · {formatMoney(Math.floor(cell.buildCost / 2))}</button>}
                    {!property.mortgaged && <button type="button" onClick={() => perform('property:mortgage', propertyId)} disabled={Boolean(busy) || !canManage}><LockKeyhole size={15} /> Заложить · {formatMoney(cell.mortgageValue)}</button>}
                    {property.mortgaged && <button type="button" onClick={() => perform('property:unmortgage', propertyId)} disabled={Boolean(busy) || !canInvest}><UnlockKeyhole size={15} /> Выкупить · {formatMoney(Math.ceil(cell.mortgageValue * 1.1))}</button>}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </div>
  );
}
